import { Text } from '@/shared/ui/core';
import cn from 'classnames';
import { BillingToggleProps } from '../model/billing-toggle.props';
import styles from './billing-toggle.module.scss';


export const BillingToggle = ({ value, onChange, discountPercent, className }: BillingToggleProps) => {
    const isMonthly = value === 'monthly';
    const isYearly  = value === 'yearly';

    return (
        <div className={ cn(styles.root, className) }>
            <div className={ styles.buttons }>
                <button
                    className={ cn(styles.button, { [styles.active]: isYearly }) }
                    onClick={ () => onChange('yearly') }
                    type="button"
                >
                    <Text
                        as="span"
                        weight="medium"
                        tone={ isYearly ? 'primary' : 'disabled' }
                        className={ styles.button_label }
                    >
                        Yearly
                    </Text>

                    {
                        !!discountPercent &&
                        <Text
                            as="span"
                            weight="semibold"
                            className={ styles.badge }
                        >
                            Save { discountPercent }%
                        </Text>
                    }
                </button>

                <button
                    className={ cn(styles.button, { [styles.active]: isMonthly }) }
                    onClick={ () => onChange('monthly') }
                    type="button"
                >
                    <Text
                        as="span"
                        weight="medium"
                        tone={ isMonthly ? 'primary' : 'disabled' }
                        className={ styles.button_label }
                    >
                        Monthly
                    </Text>
                </button>
            </div>


            {
                !!discountPercent &&
                isMonthly &&
                <Text
                    as="span"
                    size="lg"
                    tone="secondary"
                    className={ styles.hint }
                >
                    Save { discountPercent }% with Yearly payment option
                </Text>
            }
        </div>
    );
};
